import Modal from "./Modal";

import useBrowser from "../../hooks/useBrowser";

import SkuEditor from "../editors/SkuEditor";

const SkuModal = ({ sku, open, onClose, onSave, clientId }) => {
  const { windowHeight, windowWidth } = useBrowser();

  return (
    <Modal
      title={sku ? sku.name : "sku_new"}
      open={open}
      onClose={onClose}
      width={"800px"}
      height={`${windowHeight - 10}px`}
    >
      <SkuEditor
        onSave={onSave}
        clientId={clientId}
        sku={sku}
      />
    </Modal>
  );
};

const styles = {
  mainContainer: {
    padding: "12px",
  },
};

export default SkuModal;
